'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'starfighter';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e037';
var svgPathData = 'M354.6 21l29.4 235 0 224-128 0 0-224 29.4-235c1.5-12 11.7-21 23.8-21l21.6 0c12.1 0 22.3 9 23.8 21zM288 256l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 72c13.3 0 24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 184 56 0 0-40c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 168c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-12.8-92.6-37c-4.4 6-11.4 9.8-19.4 9.8-13.3 0-24-10.7-24-24l0-248c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 280c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-88 35.2 0 12.8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-168c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 40 56 0 0-184c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarfighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;